document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rt-home [data-home-add][data-has-variants="false"]').forEach(function (button) {
    if (button.textContent.trim() === 'View Options') {
      button.textContent = 'Add';
    }
  });

  document.querySelectorAll('.rt-home__hero-card[data-href]').forEach(function (card) {
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        card.click();
      }
    });
  });
});
